import React, { Component } from "react";
import { connect } from "react-redux";

import { Redirect, withRouter } from "react-router";
import ProductHeader from "../ProductDetails/ProductHeader";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import { Button, CircularProgress, Divider } from "@material-ui/core";
import instance from "../../store/actions/instance";
import moment from "moment";
import { ReactComponent as WalletIcon } from "./assets/wallet.svg";
import { ReactComponent as Empty } from "../PastOrders/assets/empty.svg";
import { getCurrencyIcon } from "../../Helpers/currencyConverter";

class Wallet extends Component {
  state = {
    history: [],
    historyLoading: false,
  };
  componentDidMount = async () => {
    try {
      this.setState({ historyLoading: true });
      const res = await instance.get("get_wallet_history/");
      this.setState({ history: res.data });
    } catch (err) {}
    this.setState({ historyLoading: false });
  };
  render() {
    const { auth, language, settings } = this.props;
    const { history, historyLoading } = this.state;
    if (
      !auth.user ||
      !settings.enable_wallet ||
      !settings.enable_wallet_staff
    ) {
      this.props.history.replace("/profile");
    }
    const currencyIcon = getCurrencyIcon(settings)
    return (
      <div
        className="text-center"
        style={{ backgroundColor: "white", minHeight: "100vh" }}
      >
        <ProductHeader onBack={() => this.props.history.replace("/profile")} />
        <div className="free-space-70-white"></div>
        <div
          style={{
            display: "flex",
            flexDirection: language === "arabic" && "row-reverse",
            alignItems: "baseline",
            justifyContent: "space-between",
          }}
          className="mx-3"
        >
          <h2 classname="bold" style={{ fontSize: 18, color: "#666666" }}>
            {language == "english" ? "Wallet" : "المحفطة"}
          </h2>
        </div>
        <div
          style={{
            display: "flex",
            gap: 30,
            flexDirection: language === "arabic" && "row-reverse",
          }}
          className="mx-4 mt-4"
        >
          <WalletIcon style={{ height: 50, width: 50 }} />
          <div
            style={{
              display: "flex",
              flex: 1,
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: language === "arabic" && "row-reverse",
            }}
          >
            <div
              style={{
                textAlign: (language === "arabic" && "right") || "left",
              }}
            >
              <p
                className="mb-1 bold"
                style={{ fontSize: 14, color: "#666666" }}
              >
                {language == "english" ? "Balance" : "الرصيد"}
              </p>
              <p
                className={"mb-1 bold".concat(
                  currencyIcon
                )}
                style={{
                  fontSize: 14,
                  color: "#666666",
                  direction: language === "arabic" ? "rtl" : "ltr",
                }}
              >
                {` ${auth.user?.wallet.toFixed(settings?.currency_decimals)}
                ${
                  language == "english"
                    ? settings?.currency_english
                    : settings?.currency_local
                }`}
              </p>
            </div>
            <Button
              className="mx-2"
              variant="contained"
              color="primary"
              disableElevation
              style={{
                borderRadius: 5,
                color: "white",
                width: 100,
                textTransform: "none",
              }}
              onClick={() =>
                this.props.history.push("/topup", {
                  prevPath: "profile",
                })
              }
            >
              <span className="bold">
                {language == "english" ? "Top-up" : "أضف رصيد"}
              </span>
            </Button>
          </div>
        </div>
        <Divider className="mt-4" />

        <div
          style={{
            display: "flex",
            flexDirection: language === "arabic" && "row-reverse",
            alignItems: "baseline",
            justifyContent: "space-between",
          }}
          className="mx-3 mt-4"
        >
          <h2 classname="bold" style={{ fontSize: 18, color: "#666666" }}>
            {language == "english" ? "History" : "السجل"}
          </h2>
        </div>

        <div class="mx-4 mt-4">
          {historyLoading ? (
            <CircularProgress color="primary" style={{ marginTop: 20 }} />
          ) : history.length <= 0 ? (
            <>
              <Empty width="100" height="100" className="mt-5" />
              <p className="mt-3">
                {language == "english"
                  ? "You don't have history"
                  : "لا يوجد سجل"}
              </p>
            </>
          ) : (
            history.map((order) => (
              <div
                style={{
                  display: "flex",
                  flexDirection: language === "arabic" && "row-reverse",
                  justifyContent: "space-between",
                }}
              >
                <p
                  className="bold"
                  style={{
                    color: "#666666",
                    flex: 1,
                    textAlign: (language === "arabic" && "right") || "left",
                  }}
                >
                  {moment(order.created).format("DD-MM-YYYY")}
                </p>
                <p
                  className="bold"
                  style={{
                    color: "#666666",
                    direction: language === "arabic" ? "rtl" : "ltr",
                    flex: 2,
                  }}
                >
                  {["topup", "manual"].includes(order.type)
                    ? (language === "arabic" && "تعبئة") || "Top-up"
                    : order.type === "cashback"
                    ? (language === "arabic" && "مبلغ مسترد") || "Cashback"
                    : order.type == "refund"
                    ? (language === "arabic" &&
                        `استرجاع ${order.tracking_id}`) ||
                      `Refunded ${order.tracking_id}`
                    : (language === "arabic" &&
                        `صرفت على ${order.tracking_id}`) ||
                      `Spent on ${order.tracking_id}`}
                </p>
                <p
                  className={"bold".concat(
                    currencyIcon
                  )}
                  style={{
                    color: ["topup", "refund", "manual", "cashback"].includes(
                      order.type
                    )
                      ? "#168C13"
                      : "#D30707",
                    direction: language === "arabic" ? "rtl" : "ltr",
                    flex: 1,
                    textAlign: (language === "arabic" && "left") || "right",
                  }}
                >
                  {`${
                    ["topup", "refund", "manual", "cashback"].includes(
                      order.type
                    )
                      ? "+"
                      : "-"
                  } ${order.amount.toFixed(settings.currency_decimals)}
                ${
                  language == "english"
                    ? settings?.currency_english
                    : settings?.currency_local
                }`}
                </p>
              </div>
            ))
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    auth: state.auth,
    settings: state.store.store.settings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Wallet));
